import * as ActionTypes from '../components/actions/types';

const initialState = {
  events: [],
  event: null
};

function cmsEventReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT:
      return {
        ...state,
        events: action.payload
      };
    case ActionTypes.FETCH_CMS_EVENT_DETAIL: {
      return {
        ...state,
        event: action.payload
      };
    }
    // case ActionTypes.CREATE_CMS_EVENT:
    //     return [...state, action.payload];
    case ActionTypes.UPDATE_CMS_EVENT:
      return {
        ...state,
        event: action.payload
      };
    case ActionTypes.REMOVE_CMS_EVENT:
      return {
        ...state,
        events: state.events.filter(event => event.id !== action.payload)
      };
    case ActionTypes.SET_COMMENTS_VISIBILITY:
      return {
        ...state,
        event: {
          ...state.event,
          judgesSubmissionCommentPublic: !state.event.judgesSubmissionCommentPublic
        }
      };
    default:
      return state;
  }
}

export default cmsEventReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEvent.js